import { OnboardingProvider } from "@/components/owner/OnboardingProvider";
import OwnerOnboardingGate from "@/components/owner/OwnerOnboardingGate";
import { Stack } from "expo-router";
import React from "react";

export default function Layout() {
  return (
    <OnboardingProvider>
      <OwnerOnboardingGate>
        <Stack screenOptions={{ headerShown: false }} />
      </OwnerOnboardingGate>
    </OnboardingProvider>
  );
}
